import React from 'react';
import { useIntl } from 'react-intl';
import Icon, { IconGlyph } from '@components/common/Icon';
import useTimeout from '@hooks/useTimeout';
import { TChildren } from '@models/common';
import styles from './Toast.module.scss';

const TOAST_DURATION = 5000;

export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
}

type ToastProps = {
  children: TChildren;
  close: () => void;
  type?: ToastType;
  duration?: number;
};

const Toast: React.FC<ToastProps> = ({
  children,
  close,
  type = ToastType.SUCCESS,
  duration = TOAST_DURATION,
}) => {
  const { formatMessage } = useIntl();
  useTimeout(close, duration);

  const isError = type === ToastType.ERROR;
  const iconGlyph = isError ? IconGlyph.TOAST_ERROR : IconGlyph.SUCCESS_FILLED;
  const iconClassName = isError ? 'c-error' : 'c-success';
  const toastClassName = isError
    ? `${styles.toast} ${styles.toastError}`
    : styles.toast;

  return (
    <div className={toastClassName}>
      <div className={styles.content}>
        <div>
          <Icon
            glyph={iconGlyph}
            className={iconClassName}
          />
        </div>
        <div className={styles.text}>{children}</div>
      </div>
      <div>
        <button
          type='button'
          onClick={close}
          className={styles.closeButton}
          aria-label={formatMessage({ id: 'toast.close_button_label' })}>
          <Icon glyph={IconGlyph.CLOSE} />
        </button>
      </div>
    </div>
  );
};

export default Toast;
